import Dashboard from "./Dashboard"
import History from "./History"
import Auth from "./Auth"
import Logout from "./Logout"
import Point from "./Point"

// eslint-disable-next-line
export default {
	Dashboard,
	History,
	Auth,
	Logout,
	Point
}
